import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import type { Client, Project, PaginatedResult } from '@shared/types'

interface Option {
  value: string
  label: string
}

export function useClientOptions() {
  const [options, setOptions] = useState<Option[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get<PaginatedResult<Client>>('/clients?limit=100')
      .then((res) => setOptions(res.data.map((c) => ({ value: c.slug, label: c.company_name }))))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  return { options, loading }
}

export function useProjectOptions(clientSlug?: string) {
  const [options, setOptions] = useState<Option[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const params = new URLSearchParams({ limit: '100' })
    if (clientSlug) params.set('client_slug', clientSlug)
    api.get<PaginatedResult<Project>>(`/projects?${params}`)
      .then((res) => setOptions(res.data.map((p) => ({ value: p.slug, label: p.name }))))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [clientSlug])

  return { options, loading }
}
